/** 房间列表：搜索范围选项 */
export const ROOM_SEARCH_SCOPE_OPTIONS = [
  { value: 'all', label: '全部字段' },
  { value: 'number', label: '房间号' },
  { value: 'houseName', label: '房源名称' },
  { value: 'houseId', label: '房源ID' },
  { value: 'roomId', label: '房间ID' },
  { value: 'tenantId', label: '租客ID' },
  { value: 'tenantPhone', label: '租客手机号' },
];

const ROOM_SEARCH_PLACEHOLDERS = {
  all: '搜索房间号、房源名称、ID或租客手机号',
  number: '请输入房间号，如：1302',
  houseName: '请输入房源名称，如：13栋',
  houseId: '请输入完整房源ID，如：13',
  roomId: '请输入完整房间ID，如：100',
  tenantId: '请输入完整租客用户ID',
  tenantPhone: '请输入租客手机号',
};

export function getRoomSearchPlaceholder(scope) {
  return ROOM_SEARCH_PLACEHOLDERS[scope] || ROOM_SEARCH_PLACEHOLDERS.all;
}

function matchText(value, keyword) {
  if (value == null || value === '') return false;
  return String(value).includes(keyword);
}

function matchId(value, keyword) {
  if (value == null || value === '') return false;
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return false;
  return String(n) === keyword;
}

function isValidTenantPhone(phone) {
  if (phone == null || phone === '') return false;
  const s = String(phone).trim();
  return s !== '' && s !== '暂无租客';
}

function roomMatchesScope(room, keyword, scope) {
  switch (scope) {
    case 'number':
      return matchText(room.number, keyword);
    case 'houseName':
      return matchText(room.houseName, keyword);
    case 'houseId':
      return matchId(room.houseId, keyword);
    case 'roomId':
      return matchId(room.id, keyword);
    case 'tenantId':
      return matchId(room.tenantId, keyword);
    case 'tenantPhone':
      return isValidTenantPhone(room.tenantPhone) && matchText(room.tenantPhone, keyword);
    case 'all':
    default:
      return (
        matchText(room.number, keyword) ||
        matchText(room.houseName, keyword) ||
        matchId(room.houseId, keyword) ||
        matchId(room.id, keyword) ||
        matchId(room.tenantId, keyword) ||
        (isValidTenantPhone(room.tenantPhone) && matchText(room.tenantPhone, keyword))
      );
  }
}

/** 按搜索范围过滤房间列表（纯前端） */
export function filterRoomList(rooms, keyword, scope = 'all') {
  const kw = String(keyword ?? '').trim();
  if (!kw || !Array.isArray(rooms)) return rooms || [];
  const effectiveScope = scope || 'all';
  return rooms.filter((room) => roomMatchesScope(room, kw, effectiveScope));
}
